import React, { useEffect, useState } from 'react';
import '../../styles/Perfil.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBuilding,
    faCamera,
    faCheck,
    faCircleUser,
    faEnvelope,
    faPen,
    faRightFromBracket,
    faUser,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';

import { signOut } from 'firebase/auth';
import { auth, db, storage } from '../../firebase/firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const PerfilOpt = () => {
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [tempData, setTempData] = useState({ name: '', empresa: '' });
    const [isEditing, setIsEditing] = useState({ name: false, empresa: false });
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [photoLoadFailed, setPhotoLoadFailed] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const fetchUserData = async (email) => {
        const docRef = doc(db, `usuarios/${email}`);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            setUserName(data.name || 'Usuário');
            setEmpresa(data.empresa || 'Empresa padrão');
            setPhotoLoadFailed(false);
            setProfilePhoto(data.photoURL || null);
        }
    };

    useEffect(() => {
        if (auth.currentUser) {
            const email = auth.currentUser.email;
            setUserEmail(email);
            setUserName(auth.currentUser.displayName || 'Usuário');
            fetchUserData(email);
        }
    }, []);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);
        const storageRef = ref(storage, `${userEmail}/fotoPerfil`);
        try {
            await uploadBytes(storageRef, file);

            const photoURL = await getDownloadURL(storageRef);
            setPhotoLoadFailed(false);
            setProfilePhoto(photoURL);

            const docRef = doc(db, `usuarios/${userEmail}`);
            await setDoc(docRef, { photoURL }, { merge: true });
        } catch (error) {
            console.error('Erro ao enviar a foto:', error);
        } finally {
            setIsUploading(false);
        }
    };

    const saveData = async (field, value) => {
        const docRef = doc(db, `usuarios/${userEmail}`);
        try {
            await setDoc(docRef, { [field]: value }, { merge: true });

            if (field === 'name') setUserName(value);
            if (field === 'empresa') setEmpresa(value);
        } catch (error) {
            console.error('Erro ao atualizar o campo:', error);
        }
    };

    const startEditing = (field) => {
        setTempData({ ...tempData, [field]: field === 'name' ? userName : empresa });
        setIsEditing({ ...isEditing, [field]: true });
    };

    const cancelEditing = (field) => {
        setIsEditing({ ...isEditing, [field]: false });
    };

    const confirmEditing = (field) => {
        saveData(field, tempData[field]);
        setIsEditing({ ...isEditing, [field]: false });
    };

    const handleLogout = () => {
        signOut(auth).then(() => {
            navigate('/');
        }).catch((error) => {
            console.error('Sign-out error:', error);
        });
    };

    const renderEditableField = ({ field, label, value, icon }) => (
        <div className='perfil-info-row'>
            <div className='perfil-info-icon'>
                <FontAwesomeIcon icon={icon} />
            </div>
            <div className='perfil-info-content'>
                <span>{label}</span>
                {isEditing[field] ? (
                    <input
                        className='txt-perfil-edit'
                        type='text'
                        value={tempData[field]}
                        onChange={(e) => setTempData({ ...tempData, [field]: e.target.value })}
                        autoFocus
                    />
                ) : (
                    <strong>{value}</strong>
                )}
            </div>
            {isEditing[field] ? (
                <div className='perfil-row-actions'>
                    <button className='btn-perfil-save' onClick={() => confirmEditing(field)} aria-label={`Salvar ${label}`}>
                        <FontAwesomeIcon icon={faCheck} />
                    </button>
                    <button className='btn-perfil-cancel' onClick={() => cancelEditing(field)} aria-label={`Cancelar ${label}`}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
            ) : (
                <button className='edit-btn' onClick={() => startEditing(field)} aria-label={`Editar ${label}`}>
                    <FontAwesomeIcon icon={faPen} />
                </button>
            )}
        </div>
    );

    const shouldShowProfilePhoto = profilePhoto && !photoLoadFailed;

    return (
        <div className='container-direito-interno'>
            <div className='perfil-section-header'>
                <span>Minha conta</span>
                <h1>Perfil</h1>
            </div>

            <div className='perfil-card perfil-overview'>
                <div className='container-img-perfil'>
                    <div className='perfil-avatar-shell'>
                        {shouldShowProfilePhoto ? (
                            <img
                                className='user-perfil-img'
                                src={profilePhoto}
                                alt='Foto de perfil'
                                onError={() => setPhotoLoadFailed(true)}
                            />
                        ) : (
                            <FontAwesomeIcon className='user-perfil-img perfil-avatar-placeholder' icon={faCircleUser} />
                        )}

                        {isUploading && <div className='spinner icon' />}

                        <label className={`perfil-photo-action ${isUploading ? 'disabled' : ''}`} htmlFor='file-input'>
                            <FontAwesomeIcon icon={faCamera} />
                        </label>
                        <input
                            id='file-input'
                            type='file'
                            accept='image/*'
                            onChange={handleFileUpload}
                            disabled={isUploading}
                        />
                    </div>
                </div>

                <div className='perfil-overview-copy'>
                    <strong>{userName}</strong>
                    <span>{empresa}</span>
                    <small>{userEmail}</small>
                </div>
            </div>

            <div className='perfil-card perfil-info-list'>
                {renderEditableField({ field: 'name', label: 'Nome', value: userName, icon: faUser })}
                {renderEditableField({ field: 'empresa', label: 'Empresa', value: empresa, icon: faBuilding })}

                <div className='perfil-info-row'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>E-mail</span>
                        <strong>{userEmail}</strong>
                    </div>
                </div>
            </div>

            <button className='btn-perfil-sair' onClick={handleLogout}>
                <FontAwesomeIcon icon={faRightFromBracket} />
                Sair
            </button>
        </div>
    );
};

export default PerfilOpt;
